import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAdminActivityActions, useAdminActivityAnalytics, useAdminUsers } from "@/lib/api";

import { ActivityDashboard } from "./activity-dashboard";

const DAYS_OPTIONS = [
  { value: "7", label: "Last 7 days" },
  { value: "30", label: "Last 30 days" },
  { value: "90", label: "Last 90 days" },
  { value: "365", label: "Last 365 days" },
];

export function AdminActivityPage() {
  const [days, setDays] = useState(30);

  const {
    data: analytics,
    isLoading: analyticsLoading,
    isError: analyticsError,
    refetch: refetchAnalytics,
  } = useAdminActivityAnalytics(days);
  const { data: users = [] } = useAdminUsers();
  const { data: actions = [] } = useAdminActivityActions();

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-primary text-2xl font-normal">Activity</h2>
          <p className="text-muted mt-1 text-sm">
            Audit logins, signups, and actions across your team
          </p>
        </div>
        <Select value={String(days)} onValueChange={(value) => setDays(Number(value))}>
          <SelectTrigger className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {DAYS_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Dashboard */}
      <div className="mt-6">
        {analyticsError ? (
          <div className="space-y-3 py-16 text-center text-sm">
            <p className="text-destructive">Failed to load activity analytics.</p>
            <Button variant="outline" size="sm" onClick={() => void refetchAnalytics()}>
              Retry
            </Button>
          </div>
        ) : analyticsLoading || !analytics ? (
          <div className="text-muted py-16 text-center text-sm">Loading activity...</div>
        ) : (
          <ActivityDashboard analytics={analytics} users={users} actions={actions} />
        )}
      </div>
    </div>
  );
}
